export default __webpack_public_path__ + "static/media/mastercard.64731639.png";